var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEsquemasActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#663ea8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_7",
    "data-name": "Capa 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bounding_Boxes",
    "data-name": "Bounding Boxes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2542",
    "data-name": "Trazado 2542",
    className: "cls-1",
    d: "M6.53,16.5h24v24h-24Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_22",
    "data-name": "Capa 22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2543",
    "data-name": "Trazado 2543",
    className: "cls-2",
    d: "M2,3.36V19.64a1.19,1.19,0,0,0,1.2,1.19H19.78A1.19,1.19,0,0,0,21,19.64V3.36a1.19,1.19,0,0,0-1.2-1.19H3.22A1.19,1.19,0,0,0,2,3.36ZM6.48,4.67v3H3.9v-3ZM3.9,13V10H6.48v3Zm0,2.33H6.48v3H3.9Zm15.29,3h-11v-3h11Zm0-5.33h-11V10h11Zm0-5.33h-11v-3h11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEsquemasActive);
export default __webpack_public_path__ + "static/media/ic-esquemas-active.8856b000da8a79dbc2d268116d59cff4.svg";
export { ForwardRef as ReactComponent };